import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';

import { FiltersComponent } from '../../../common/filters.component';
import { Data2Service } from '../../../common/data2.service';

@Component({
	selector: 'app-php-tasks-list-filters',
	templateUrl: './php-tasks-list-filters.component.html',
	styleUrls: ['./php-tasks-list-filters.component.css'],
})
export class PhpTasksListFiltersComponent extends FiltersComponent {
	filters = {
		status: 1,
		type: null,
		objType: null,
	};
	@Input() statuses: Array<any> = [];
	@Input() types: Array<any> = [];
	@Input() objTypes: Array<any> = [];
}
